import { Box, Text, Image, Button, Flex, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Insta from "../../images/insta_logo.png";
import Facebook from "../../images/facebook_logo.png";
import Youtube from "../../images/youtube_logo.png";
import tiktok from "../../images/tictok_logo.png";
import { adminHideCampaign, adminShowCampaign, campaignPayment } from "../../api";

export default function RecruitingCard({ item, type, nobutton, onChanged }) {
  const navigate = useNavigate();
  const toast = useToast();

  const PLATFORM_ICONS = {
    instagram: Insta,
    facebook: Facebook,
    tiktok: tiktok,
    youtube: Youtube,
  };

  const renderStatusTag = () => {
    if (item?.campaignStatus === "PENDING_PAYMENT")
      return { label: "결제 대기중", bg: "#9050FF" };
    if (item?.campaignStatus === "RECRUITING")
      return { label: "모집중", bg: "#9050FF" };
    if (item?.campaignStatus === "CONTRACTED")
      return { label: "모집 마감(기간 만료)", bg: "#A2A9B3" };
    if (item?.campaignStatus === "OFFERING")
      return { label: "제안 진행중", bg: "#A2A9B3" };
    return null;
  };

  const statusTag = renderStatusTag();
  const visibilityTag = item?.deletedAt
    ? { label: "숨김", bg: "#E53E3E" }
    : { label: "노출", bg: "#38A169" };

  const errorMessage = (e) =>
    e?.response?.data?.error?.message ||
    e?.response?.data?.message ||
    e?.response?.data?.detail ||
    "캠페인 결제 중 오류가 발생했습니다.";

  async function handleChangeStatus(id) {
    try {
      await campaignPayment({ id });

      toast({
        title: "캠페인 예산 결제 완료",
        description: "캠페인이 결제가 완료되었습니다.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (e) {
      toast({
        title: "오류 발생",
        description: errorMessage(e),
        status: "error",
        duration: 2500,
        isClosable: true,
      });
    }
  }

  async function handleVisibilityChange(id, hidden) {
    try {
      if (hidden) {
        await adminShowCampaign({ id });
      } else {
        await adminHideCampaign({ id });
      }
      toast({
        title: hidden ? "캠페인을 노출했습니다." : "캠페인을 숨김 처리했습니다.",
        status: "success",
        duration: 1800,
        isClosable: true,
      });
      onChanged?.();
    } catch (e) {
      toast({
        title: "상태 변경 실패",
        description: errorMessage(e),
        status: "error",
        duration: 2500,
        isClosable: true,
      });
    }
  }

  return (
    <Flex
      position="relative"
      w="100%"
      bg="white"
      p="12px"
      flexDir="column"
      alignItems="center"
      borderRadius="12px"
      boxShadow="0px 2px 6px rgba(0,0,0,0.08)"
      border="1px solid #E2E8F0"
      _hover={{ boxShadow: "0px 4px 12px rgba(0,0,0,0.12)" }}
      transition="0.2s"
      gap="12px"
    >
      <Flex
        position="absolute"
        top="-0.1px"
        left="0.1px"
        gap="6px"
        zIndex={10}
      >
        {[(nobutton ? null : statusTag), visibilityTag].filter(Boolean).map((tag) => (
            <Box
              key={tag.label}
              bg={tag.bg}
              color="white"
              px="10px"
              py="3px"
              fontSize="12px"
              borderRadius="8px"
              fontWeight="700"
              boxShadow="0 2px 6px rgba(0,0,0,0.12)"
            >
              {tag.label}
            </Box>
        ))}
      </Flex>

      <Flex w="100%" flexDir="row" gap="8px">
        {/* 캠페인 이미지 */}
        <Image
          src={item?.productImageUrl}
          alt="campaign"
          w="25%"
          h="180px"
          objectFit="cover"
          borderRadius="8px"
        />
        {/* 왼쪽 정보 */}
        <Flex w="25%" flexDir="column" flex="1" gap="10px" py="12px" mr="10px">
          <Flex justifyContent="space-between" alignItems="center">
            <Text
              w="85%"
              fontSize="22px"
              fontWeight="700"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {item?.title}
            </Text>

            {/* CPUC 배지 */}
            <Box
              w="45px"
              h="20px"
              textAlign="center"
              fontSize="12px"
              bg="#F1E9FF"
              color="#7A39FF"
              borderRadius="6px"
              fontWeight="700"
            >
              {item?.billingModel}
            </Box>
          </Flex>

          <Text fontSize="18px" lineHeight="120%" color="#4A5568">
            {item?.description}
          </Text>
        </Flex>
        {/* 플랫폼 + 모집 마감일 + 카테고리 */}
        <Flex w="25%" gap="8px" flexDir="column">
          {/* 플랫폼 */}
          <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
            <Text fontSize="12px" fontWeight={500} color="#6B7280" mb="2px">
              플랫폼
            </Text>
            <Flex alignItems="center" gap="16px" overflowX="auto">
              {item?.channelsJson?.map((platform) => {
                const key = platform.toLowerCase();
                const icon = PLATFORM_ICONS[key];

                return (
                  <Flex key={key} align="center" gap="4px" mr="8px">
                    {icon && (
                      <Image src={icon} w="18px" h="18px" alt={platform} />
                    )}
                    <Text fontSize="16px" fontWeight="600">
                      {platform}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
          </Box>

          {/* 모집 마감일 */}
          <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
            <Text fontSize="12px" fontWeight={500} color="#6B7280" mb="2px">
              모집 마감일
            </Text>
            <Text fontSize="16px" fontWeight="600">
              {item?.runEnd?.split("T")[0]}
            </Text>
          </Box>

          {/* <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
            <Text fontSize="12px" fontWeight={500} color="#6B7280" mb="2px">
              캠페인 유형/비용
            </Text>
            <Text fontSize="16px" fontWeight="600">
              {item?.billingModel} / {item?.totalBudget}
            </Text>
          </Box> */}

          {/* 카테고리 */}
          <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
            <Text fontSize="12px" fontWeight={500} color="#6B7280" mb="2px">
              산업 카테고리
            </Text>
            <Box
              maxW="90%"
              overflowX="auto"
              whiteSpace="nowrap"
              css={{ "&::-webkit-scrollbar": { display: "none" } }}
            >
              {item.industryCategories.length > 0 ? (
                <Flex gap="6px">
                  {item.industryCategories.map((idx) => (
                    <Box
                      key={idx.id}
                      px="8px"
                      py="2px"
                      bg="#E9F2FF"
                      color="#4B5563"
                      fontSize="12px"
                      borderRadius="6px"
                      flexShrink={0}
                    >
                      {idx.nameKo}
                    </Box>
                  ))}
                </Flex>
              ) : (
                <Text fontSize="12px" color="gray.400">
                  카테고리 없음
                </Text>
              )}
            </Box>
          </Box>
        </Flex>

        {/* 오른쪽 상세 정보 + 버튼 */}
        <Flex w="25%" flexDir="column" justifyContent="space-between">
          <Flex flexDir="column" gap="10px">
            <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
              <Text fontSize="12px" fontWeight={500} color="#6B7280">
                국가
              </Text>
              <Text fontSize="16px" fontWeight="600">
                {item?.country}
              </Text>
            </Box>

            <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
              <Text fontSize="12px" fontWeight={500} color="#6B7280">
                예상 캠페인 기간
              </Text>
              <Text fontSize="16px" fontWeight="600">
                {item?.runStart?.split("T")[0]} ~ {item?.runEnd?.split("T")[0]}
              </Text>
            </Box>

            <Box border="1px solid #D1D4D9" borderRadius="8px" p="8px">
              <Text fontSize="12px" fontWeight={500} color="#6B7280" mb="2px">
                라이프스타일 카테고리
              </Text>
              <Box
                maxW="90%"
                overflowX="auto"
                whiteSpace="nowrap"
                css={{ "&::-webkit-scrollbar": { display: "none" } }}
              >
                {item.lifestyleCategories.length > 0 ? (
                  <Flex gap="6px">
                    {item.lifestyleCategories.map((idx) => (
                      <Box
                        key={idx.id}
                        px="8px"
                        py="2px"
                        bg="#E9F2FF"
                        color="#4B5563"
                        fontSize="12px"
                        borderRadius="6px"
                        flexShrink={0}
                      >
                        {idx.nameKo}
                      </Box>
                    ))}
                  </Flex>
                ) : (
                  <Text fontSize="12px" color="gray.400">
                    카테고리 없음
                  </Text>
                )}
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Flex>
      {nobutton ? (
        <Box></Box>
      ) : (
        <Flex gap="20px">
          {item?.campaignStatus === "PENDING_PAYMENT" && (
            <Button
              w="123px"
              h="44px"
              bg="white"
              border="1px solid #0054C0"
              color="#0054C0"
              borderRadius="12px"
              fontSize="14px"
              onClick={() => handleChangeStatus(item.campaignId)}
            >
              캠페인 예산 결제
            </Button>
          )}

          {["PENDING_PAYMENT", "RECRUITING"].includes(item?.campaignStatus) && (
            <Button
              w="96px"
              h="44px"
              bg="white"
              border="1px solid #718096"
              color="#2D3748"
              borderRadius="12px"
              fontSize="14px"
              onClick={() =>
                handleVisibilityChange(item.campaignId, Boolean(item.deletedAt))
              }
            >
              {item.deletedAt ? "노출하기" : "숨기기"}
            </Button>
          )}

          <Button
            w="96px"
            h="44px"
            bg="#0054C0"
            color="white"
            borderRadius="12px"
            fontSize="14px"
            onClick={() =>
              navigate(
                `/suggest/${item?.campaignStatus?.toLowerCase()}/${
                  item.campaignId
                }`
              )
            }
          >
            상세보기
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
